import type { OverlayOptions } from '@nuxt/ui/runtime/composables/useOverlay.js'
import type { Component } from 'vue'
import type { ComponentProps } from 'vue-component-type-helpers'
import SuccessModal from '~/components/SuccessModal.vue'

export const useModal = <T extends Component>(
  component: T,
  options?: OverlayOptions<ComponentProps<T>>,
) => {
  const overlay = useOverlay()
  const modal = overlay.create(component, options)

  return modal
}

export const useSuccessModal = (data?: {
  title?: string
  description?: string
}) => {
  const title = data?.title ?? 'Спасибо, ваша заявка отправлена'

  const { open, close } = useModal(SuccessModal, {
    props: {
      title,
      description: data?.description,
    },
  })

  return {
    open,
    close,
  }
}
